// Délais et réglages communs de la page des commandes.

export const DELETE_UNDO_SECONDS = 15;

export const LOCK_LIST_REFRESH_MS = 30_000;

export const PENDING_MEDICAMENT_DESTINATION = "NONE";

export const LOCK_LOST = Symbol("lock-lost");

export const SAVE_REQUEST_CONFIG = { noRedirectOn401: true };

export const AUTOSAVE_DELAY_MS = 2500;

export const EMPTY_CONTEXT = {};

export const EMPTY_FILTERS = {};
